export default __webpack_public_path__ + "static/media/1 - Зарядные станции для экотранспорта.2d8ac730.jpg";